export const SHORTCUTS_PANEL_MIN = 240;
export const SHORTCUTS_PANEL_DEFAULT = 350;
export const SHORTCUTS_PANEL_MAX = 720;

function storageKey(uid) {
  return `signalbridge.shortcuts.panel.${uid || 'anon'}`;
}

export function clampShortcutsPanelWidth(value, viewportWidth = 1280) {
  const width = Math.round(Number(value));
  const room = Math.max(SHORTCUTS_PANEL_MIN, Math.round(Number(viewportWidth) || 1280) - 80);
  const max = Math.min(SHORTCUTS_PANEL_MAX, room);
  if (!Number.isFinite(width)) return Math.min(SHORTCUTS_PANEL_DEFAULT, max);
  return Math.min(max, Math.max(SHORTCUTS_PANEL_MIN, width));
}

export function loadShortcutsPanelState(uid) {
  try {
    const raw = localStorage.getItem(storageKey(uid));
    if (!raw) {
      return { open: false, width: SHORTCUTS_PANEL_DEFAULT };
    }
    const parsed = JSON.parse(raw);
    return {
      open: Boolean(parsed?.open),
      width: clampShortcutsPanelWidth(parsed?.width),
    };
  } catch {
    return { open: false, width: SHORTCUTS_PANEL_DEFAULT };
  }
}

export function saveShortcutsPanelState(uid, next) {
  try {
    const current = loadShortcutsPanelState(uid);
    const open = next.open == null ? current.open : Boolean(next.open);
    const width = clampShortcutsPanelWidth(next.width == null ? current.width : next.width);
    localStorage.setItem(storageKey(uid), JSON.stringify({ open, width }));
    return { open, width };
  } catch {
    return {
      open: Boolean(next?.open),
      width: clampShortcutsPanelWidth(next?.width),
    };
  }
}
